/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  FormGroup,
  Modal,
} from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import "moment-duration-format";

// actions
import {
  resetScripts,
  resetError,
  getScripts,
  deleteScript,
} from "../../store/script/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

import BadgesEllipsis from "../../components/Common/BadgesEllipsis";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Scripts = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataScript,
    dataScriptDelete,
    loadingScript,
    loadingScriptDelete,
    errorScript,
    successScript,
  } = useSelector((state) => state.Script);

  const [page, setPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [scriptId, setScriptId] = useState("");
  const [scriptName, setScriptName] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  const [notFound, setNotFound] = useState(false);

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successScript &&
      dispatch(resetScripts()) &&
      handleFilter(),
  };

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getScripts(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteScript(scriptId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setScriptIdName = (script) => {
    setScriptId(script.id);
    setScriptName(script.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getScripts(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataScript && dataScript.paging) {
      if (page < dataScript.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  useEffect(() => {
    if (dataScriptDelete && dataScriptDelete.message) {
      showToast("success", t(dataScriptDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successScript]);

  useEffect(() => {
    if (errorScript && typeof errorScript === "object") {
      errorScript.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Script not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorScript) {
        showToast("error", t(errorScript));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorScript]);

  useEffect(() => {
    if (dataScript !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataScript]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/scripts"
            title={t("Dashboard")}
            breadcrumbItem={t("Scripts")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="3" xl="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Title")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Title") + "..."}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div
                          className="text-sm-right mb-3"
                          id="new-script"
                        >
                          <Link to={`/script`}>
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Script")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Title")}</th>
                            <th>{t("Text")}</th>
                            <th>{t("Skills")}</th>
                            <th>{t("Categories")}</th>
                            <th>{t("Global")}</th>
                            <th>{t("Activated")}</th>
                            <th className="text-right pr-4">{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingScript ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataScript &&
                            dataScript.scripts &&
                            dataScript.scripts.length >
                              0 ? (
                            dataScript.scripts.map(
                              (script, key) => (
                                <tr key={key}>
                                  <td className="pl-4">{key + 1}</td>
                                  <td className="column-text-overflow-25">
                                    {script.title}
                                  </td>
                                  <td className="column-text-overflow-25">
                                    {script.text}
                                  </td>
                                  <td>
                                    {Array.isArray(script.skills) &&
                                    script.skills.length > 0 ? (
                                      <BadgesEllipsis
                                        objItems={script.skills}
                                        //sizePx={150}
                                      />
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {Array.isArray(script.categories) &&
                                    script?.categories.length>0 ? (
                                      <BadgesEllipsis
                                      objItems={script.categories.map((e, key)=>({id: key, name: e}))}
                                      //sizePx={150}
                                      />
                                    ) : (
                                      "-"
                                    )
                                  } 
                                  </td>
                                  <td className="text-center">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={script.global}
                                        readOnly
                                      />
                                      <label className="custom-control-label"></label>
                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        checked={script.activated}
                                        readOnly
                                      />
                                      <label className="custom-control-label"></label>
                                    </div>
                                  </td>
                                  <td className="text-right">
                                    <Link
                                      to={`/script/${script.id}`}
                                      className="text-primary text-center"
                                      id="edit"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18 px-2"
                                        id={`edittooltip${key}`}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target={`edittooltip${key}`}
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </Link>
                                    {/* TODO: add custom styles to css file */}
                                    <span className="pointer">
                                      <i
                                        className="mdi mdi-window-close text-danger font-size-18 px-2"
                                        id={`deletetooltip${key}`}
                                        onClick={() => {
                                          toggleModal();
                                          setScriptIdName(
                                            script
                                          );
                                        }}
                                      ></i>
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target={`deletetooltip${key}`}
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingScriptDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want to delete the script")}
                          <strong> {scriptName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>
                          {loadingScriptDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              disabled
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                toggleModal();
                                if (scriptId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataScript?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Scripts);
